// App Components

import {
  registerLocaleData,
  isPlatformBrowser,
  CommonModule,
} from "@angular/common";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { NgModule, Inject, PLATFORM_ID, APP_ID } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule, BrowserTransferStateModule, Meta } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CarouselModule } from "ngx-owl-carousel-o";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { AppRoutingModule } from "./app-routing.module";

import { ContactService } from "../services/contact/contact.service";
import { HomeService } from "../services/home/home.service";
import { LearningService } from "../services/learning/learning.service";
import { en_US, NZ_I18N, NzI18nModule } from "ng-zorro-antd/i18n";
import { SharedModule } from "../components/shared.module";
import { SchoolsSysyrmModule } from "src/components/schools-sysyrm/schools-sysyrm.module";
import { AppComponent } from "./app.component";
import { CustomHttpInterceptorInterceptor } from "./custom-http-interceptor.interceptor";
import { HttpInterceptorService } from "./universal-interceprtor";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CookieService } from "ngx-cookie-service";
import { AdvertiseHomeComponent } from "src/components/home/advertise-home/advertise-home.component";

registerLocaleData("en");

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/lang/", ".json");
}

@NgModule({
  declarations: [
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "serverApp" }),
    CarouselModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SchoolsSysyrmModule,
    SlickCarouselModule,
    BrowserTransferStateModule
    ,TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    HomeService,
    Meta,
    ContactService,
    LearningService,
    ,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    CookieService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(APP_ID) private appId: string
  ) {
    const platform = isPlatformBrowser(platformId)
      ? "in the browser"
      : "on the server";
    console.log(`Running ${platform} with appId=${appId}`);
  }
}
